import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { darken } from '@mui/material/styles';

// Definición de colores para cada opción
const severityColors = {
  Light: '#2E8B57',
  Severe: '#dfcd1a',
  Lightning: '#FFA500',
  High_Density_Lightning: '#FF4500',
  Overshoot: '#800080'
};

// Opciones con valores y etiquetas
const options = [
  { value: 'Light', label: 'Light' },
  { value: 'Severe', label: 'Severe' },
  { value: 'Lightning', label: 'Lightning' },
  { value: 'High_Density_Lightning', label: 'High-density lightning' },
  { value: 'Overshoot', label: 'Overshoot' }  
];

const SeveritySelector = ({ value, onChange }) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, newValue) => {
        if (newValue !== null) onChange(newValue);
      }}
      aria-label="Severity selection"
      sx={{
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        boxShadow: '0px 2px 5px rgba(0,0,0,0.2)',
      }}
    >
      {options.map((option) => (
        <ToggleButton 
          key={option.value} 
          value={option.value} 
          aria-label={option.label}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
            backgroundColor: value === option.value ? severityColors[option.value] : 'transparent', 
            color: value === option.value ? 'white' : 'black',
            opacity: value === option.value ? 1 : 0.5, // ⚡ Opacidad reducida en no seleccionados
            minWidth: '40px',
            minHeight: '32px',
            padding: '4px 8px',
            borderRadius: '6px',
            transition: 'background-color 0.3s ease, opacity 0.3s ease',
            '&:hover': {
              backgroundColor: value === option.value 
                ? darken(severityColors[option.value], 0.2) 
                : '#e0e0e0',
              opacity: 0.7, // ⚡ Hover con más contraste en no seleccionados
            },
            '&.Mui-selected': {
              backgroundColor: severityColors[option.value],
              color: 'white',
              opacity: 1,
              '&:hover': {
                backgroundColor: darken(severityColors[option.value], 0.2),
              },
            },
          }}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default SeveritySelector;
